'use client';

import Script from 'next/script';
import { useState } from 'react';
import { FooterTrustpilotSkeleton } from './FooterTrustpilotSkeleton';
import TrustpilotWidget from './TrustpilotWidget';

export default function FooterTrustpilot() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  if (error) return null;

  return (
    <>
      <Script
        onReady={() => setLoading(false)}
        onError={() => setError(true)}
        src="//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js"
      />
      <TrustpilotWidget />
      {loading ? <FooterTrustpilotSkeleton /> : null}
    </>
  );
}
